import IPagination from "interfaces/IPagination";

export const paginationInitialData: IPagination<any> = {
    count: 0,
    items: [],
    page: 0,
    totalItems: 0,
    totalPages: 0
};
